import NCM from './ncm'
import CEST from './cest'
import CFOP from './cfop'
import ICMS from './template-icms'
import SelectICMS from './template-icms/select'
import IPI from './ipi'
import PIS from './pis'

export {
    NCM,
    CEST,
    CFOP,
    ICMS,
    SelectICMS,
    IPI,
    PIS
}


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/index.jsx